import StyledAgentAvatar from './StyledAgentAvatar';
import useNavigateToAgentDashboard from '../../../hooks/useNavigateToAgentDashboard';
import { AgentType, AgentVoice } from '../../../interfaces/Agent';
import useLoadAgentImage from '../../../hooks/useLoadAgentImage';
import { useTranslation } from '../../../hooks/useTranslation';
import TextTruncated from '../TextTruncated/TextTruncated';
import { Skeleton, Stack } from '@mui/material';

type AgentAvatarProps = {
  imageFileName: string | null;
  agentName: string;
  agentId?: string;
  voice?: AgentVoice;
  agentType?: AgentType;
};

const AgentAvatar: React.FC<AgentAvatarProps> = ({
  agentName,
  imageFileName,
  agentId,
  voice,
  agentType = AgentType.CALL,
}) => {
  const { navigateToAgentDashboard } = useNavigateToAgentDashboard();
  const { imgSrc } = useLoadAgentImage(imageFileName, voice, '40x40');
  const { t } = useTranslation();

  return (
    <StyledAgentAvatar
      onClick={() => navigateToAgentDashboard(agentId, agentType)}
    >
      {agentType === AgentType.CALL && imgSrc && (
        <img
          src={imgSrc ?? ''}
          width={40}
          height={40}
          alt={t("The agent's avatar")}
        />
      )}
      {agentType === AgentType.CHAT && imageFileName && (
        <img
          src={imageFileName ?? ''}
          width={40}
          height={40}
          alt={t("The agent's avatar")}
        />
      )}
      {!imgSrc && !imageFileName && (
        <Stack>
          <Skeleton variant="circular" width="40px" height="40px" />
        </Stack>
      )}
      <TextTruncated title={agentName} width="100px">
        {agentName}
      </TextTruncated>
    </StyledAgentAvatar>
  );
};

export default AgentAvatar;
